import React from "react";
import Logo from "../../img/Logo Branca 2.png";
import "../../index.css";
import "./style.css";
import {Menu} from "../Menu";

export const Header = ({route}:any) => {
    return (
        <div className="header">
            <img src={Logo} alt="" />
            <Menu route={route} />
        </div>
    );
};
